import React from 'react'
import { connect } from 'react-redux'
import ClassNames from 'classnames'
import uuid from 'node-uuid'
import removeMessage from '../action-creators/remove-message'
import Message from './Message'

export const MessageList = props => (
  <div>
    {props.messages.map(m => {
      const classNames = ClassNames('alert fade in', {
        'alert-danger': m.type === 'error',
        'alert-success': m.type === 'success'
      })
      return (
        <Message
          key={uuid.v1()}
          classNames={classNames}
          text={m.text}
          onDismiss={props.dismissMessage.bind(null, m.id)} />
    )})}
  </div>
)

MessageList.propTypes = {
  messages: React.PropTypes.array.isRequired,
  dismissMessage: React.PropTypes.func.isRequired
}

export default connect(
  state => ({ messages: state.messages.items }),
  dispatch => ({ dismissMessage: id => dispatch(removeMessage(id))})
)(MessageList)



// WEBPACK FOOTER //
// ./src/app/components/MessageList.js